import { createSlice, nanoid, type PayloadAction } from "@reduxjs/toolkit";

import type { OtaSettlementRule } from "@/types/api";

interface OtaChannelsState {
  items: OtaSettlementRule[];
}

const seed: OtaSettlementRule[] = [
  {
    id: "ota-1",
    channel: "booking.com",
    settlement_type: "weekly_friday",
    cycle_day_of_week: 5,
  },
  {
    id: "ota-2",
    channel: "expedia",
    settlement_type: "same_day",
    cycle_day_of_week: null,
  },
  {
    id: "ota-3",
    channel: "direct",
    settlement_type: "same_day",
    cycle_day_of_week: null,
  },
  {
    id: "ota-4",
    channel: "corporate",
    settlement_type: "invoice",
    cycle_day_of_week: null,
  },
];

const initialState: OtaChannelsState = { items: seed };

export type OtaSettlementInput = Omit<OtaSettlementRule, "id">;

const slice = createSlice({
  name: "otaChannels",
  initialState,
  reducers: {
    addChannel(state, action: PayloadAction<OtaSettlementInput>) {
      const id = `ota-${nanoid(6)}`;
      state.items.unshift({ ...action.payload, id });
    },
    updateChannel(
      state,
      action: PayloadAction<{ id: string; patch: Partial<OtaSettlementRule> }>,
    ) {
      const row = state.items.find((r) => r.id === action.payload.id);
      if (row) Object.assign(row, action.payload.patch);
    },
    deleteChannel(state, action: PayloadAction<string>) {
      state.items = state.items.filter((r) => r.id !== action.payload);
    },
  },
});

export const { addChannel, updateChannel, deleteChannel } = slice.actions;
export default slice.reducer;
